"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPhoneNumberDto = instanceOfPhoneNumberDto;
exports.PhoneNumberDtoFromJSON = PhoneNumberDtoFromJSON;
exports.PhoneNumberDtoFromJSONTyped = PhoneNumberDtoFromJSONTyped;
exports.PhoneNumberDtoToJSON = PhoneNumberDtoToJSON;
exports.PhoneNumberDtoToJSONTyped = PhoneNumberDtoToJSONTyped;
/**
 * Check if a given object implements the PhoneNumberDto interface.
 */
function instanceOfPhoneNumberDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('number' in value) || value['number'] === undefined)
        return false;
    return true;
}
function PhoneNumberDtoFromJSON(json) {
    return PhoneNumberDtoFromJSONTyped(json, false);
}
function PhoneNumberDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'number': json['number'],
        'extension': json['extension'] == null ? undefined : json['extension'],
        'receiveSms': json['receiveSms'] == null ? undefined : json['receiveSms'],
        'carrierSmsOptOut': json['carrierSmsOptOut'] == null ? undefined : json['carrierSmsOptOut'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function PhoneNumberDtoToJSON(json) {
    return PhoneNumberDtoToJSONTyped(json, false);
}
function PhoneNumberDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'number': value['number'],
        'extension': value['extension'],
        'receiveSms': value['receiveSms'],
        'carrierSmsOptOut': value['carrierSmsOptOut'],
        'type': value['type'],
    };
}
//# sourceMappingURL=PhoneNumberDto.js.map